module.exports = __webpack_public_path__ + "img/cmty-logo.9c5b658b.png";